export const isloggedIn = () => {
  return (
    !!localStorage.getItem("ACCESS_TOKEN") && !!localStorage.getItem("email")
  );
};

export const logout = () => {
  localStorage.removeItem("USER_EMAIL");
  localStorage.removeItem("USER_NAME");
  localStorage.removeItem("IS_ADV");
  localStorage.removeItem("ACCESS_TOKEN");
  localStorage.removeItem("LOGO");
  setTimeout(() => {
    window.location.reload();
  }, 2000);
};
